module.exports = __webpack_public_path__ + "media/images/categories/color/support-sm-f038161438f72f3d61d39a974c05f4cf.png";